import { render, staticRenderFns } from "./PbDropdown.vue?vue&type=template&id=33879519&"
import script from "./PbDropdown.vue?vue&type=script&lang=js&"
export * from "./PbDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports